import React from "react";
import { format } from "date-fns";
import sourcesStore from "../../store/sources";
import { useModal } from "../../utils/hooks";
import { Spinner } from "../../utils/styles";
import {
  Container,
  StyledSpinner,
  TableActions,
  DeleteButton,
  MessageContainer,
  ActionButtonsContainer
} from "../styles";
import { InsertButton } from "./styles";

import DeleteConfirmation from "../../modals/DeleteConfirmation/DeleteConfirmation";
import CreateSource from "../../modals/CreateSource/CreateSource";

import Table from "../Table/Table";
import Search from "../Search/Search";

export default () => {
  const {
    data,
    error,
    loading,
    sortField,
    sortDirection,
    numElemsSelected,
    firstLoad
  } = sourcesStore.useData();
  const sort = sourcesStore.useSort();
  const {
    currentFilter,
    filterField,
    setCurrentFilter,
    setFilterField
  } = sourcesStore.useFilter();
  const togglesource = sourcesStore.useToggleElement();
  const toggleAllsources = sourcesStore.useToggleAllElements();
  const {
    makeRequest: updateSources,
    loading: updateLoading
  } = sourcesStore.usePutNewData();

  const [ShowDeleteConfirmationModal] = useModal(
    () => (
      <DeleteConfirmation
        useRequest={sourcesStore.useDeleteSelected}
        confirmationMessage={`${numElemsSelected} sources will be deleted.
        Do you want to continue?`}
        loadingMessage={"Deleting sources..."}
      />
    ),
    {
      variables: [numElemsSelected]
    }
  );

  const [showCreatesourceModal] = useModal(() => <CreateSource />, {
    variables: []
  });

  const onEditField = row => {
    updateSources({ data: [row] });
  };

  const fields = [
    {
      name: "mn_source_name",
      width: 150,
      label: "Source Name",
      onEdit: onEditField
    },
    {
      name: "created_at",
      width: 100,
      label: "Created At",
      format: value => value && format(new Date(value), "YYYY-MM-DD")
    },
    {
      name: "updated_at",
      width: 100,
      label: "Updated At",
      format: value => value && format(new Date(value), "YYYY-MM-DD")
    },
    {
      name: "deleted_at",
      width: 100,
      label: "Deleted At",
      format: value => value && format(new Date(value), "YYYY-MM-DD")
    }
  ];

  const onFilterChange = e => {
    const value = e.target.value;
    setCurrentFilter({ value });
  };

  const onFilterFieldChange = e => {
    const value = e.target.value;
    setFilterField({ field: value });
  };

  const onSelectAll = allRowsSelected => {
    toggleAllsources({ selected: allRowsSelected });
  };

  const onSelectsource = source => {
    togglesource({ id: source.mn_source_id });
  };

  const renderMessage = () => {
    if (error)
      return <span>There was an error loading sources. {error.message}</span>;
    if (updateLoading) {
      return (
        <>
          <StyledSpinner />
          Updating source...
        </>
      );
    }
    if (loading)
      return (
        <span>
          <Spinner /> Loading sources...
        </span>
      );
    if (numElemsSelected)
      return (
        <span>
          {numElemsSelected} {numElemsSelected === 1 ? "source" : "sources"}{" "}
          selected
        </span>
      );
  };

  return (
    <Container>
      <TableActions>
        {firstLoad && (
          <ActionButtonsContainer>
            <InsertButton onClick={showCreatesourceModal}>
              New source
            </InsertButton>
            <DeleteButton
              onClick={ShowDeleteConfirmationModal}
              disabled={numElemsSelected === 0}
            >
              Delete
            </DeleteButton>
          </ActionButtonsContainer>
        )}
        <MessageContainer>{renderMessage()}</MessageContainer>
        {firstLoad && (
          <Search
            currentFilter={currentFilter}
            filterField={filterField}
            onFilterChange={onFilterChange}
            onFilterFieldChange={onFilterFieldChange}
            fields={fields}
          />
        )}
      </TableActions>
      <Table
        selectable
        height={800}
        emptyRows={25}
        fixCheckboxes={false}
        fields={fields}
        sortField={sortField}
        sortDirection={sortDirection}
        data={data}
        onSort={sort}
        onSelectAll={onSelectAll}
        onSelectRow={onSelectsource}
      />
    </Container>
  );
};
